export default [
    'order_id',
    'shipment_id',
    'payout_number',
    'invoice_number',
    'equipment_id',
    'scac_code',
    'credit_memo_number',
    'trinium_order_id',
];
